import {Pipe, PipeTransform} from '@angular/core';
import {DateTime} from 'luxon';

@Pipe({
    name: 'unixTime',
    standalone: true
})
export class UnixTimePipe implements PipeTransform {

  transform(value: number | undefined, format?: string): string {
    if (!value) {
      return '';
    }

    let date;
    date = DateTime.fromSeconds(value);

    if (date.isValid) {
      if (format === 'today') {
        const today = DateTime.local();
        const diff = date.diff(today, 'days');
        // console.log(diff);
        if (diff.days < 1 && diff.days >= 0) {
          return date.toFormat('hh:mm a');
        } else {
          return date.toFormat('M/dd/yyyy hh:mm a');
        }
      } else {
        return date.toFormat(format || 'M/dd/yyyy hh:mm a');
      }
    }

    return value.toString();
  }
}
